import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const FilterIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-filter-icon': true,
      [className]: className,
    })}
    name={IconNames.FILTER}
    size={size}
    {...rest}
  />
);

FilterIcon.propTypes = {
  ...iconPropTypes,
};

FilterIcon.defaultProps = {
  ...iconDefaultProps,
};


export default FilterIcon;
